import type { Client } from '@standardsdigital/ui-components/Logo';
import NotFoundPage from '@/components/pages/NotFoundPage';
import HeaderSection from '@/components/global/Header';
import FooterSection from '@/components/global/Footer';
import ToastWrapper from '../global/ToastWrapper';
import type { HeaderModel } from '@/redux/services/generatedApi/header';
import type { FooterModel } from '@/redux/services/generatedApi/footer';
import type { NullableOptional } from '@/types/util';
import getClientLogo from '@/branding/getClientLogo';
import getLogoLangCode from '@/util/getLogoLangCode';

export enum ComponentName {
  NotFound = 'NotFoundPage',
  Header = 'Header',
  Footer = 'Footer',
}

interface MainProps {
  componentName: ComponentName;
  translations: string | undefined;
  language: string | undefined;
  clientCode: Client;
  headerData: NullableOptional<HeaderModel> | null;
  footerData: NullableOptional<FooterModel> | null;
  searchInputMaxLength: string | undefined;
}

function Main({
  componentName,
  translations: jsonTranslations,
  language,
  clientCode,
  headerData,
  footerData,
  searchInputMaxLength,
}: MainProps) {
  const langCode = getLogoLangCode(language);

  const getComponent = () => {
    switch (componentName) {
      case ComponentName.Header:
        return (
          <HeaderSection
            translations={jsonTranslations}
            logo={getClientLogo(clientCode, langCode)}
            language={language}
            data={headerData}
            searchInputMaxLength={searchInputMaxLength}
          />
        );
      case ComponentName.Footer:
        return (
          <FooterSection
            translations={jsonTranslations}
            language={language}
            data={footerData}
            renderLogo={getClientLogo}
          />
        );
      case ComponentName.NotFound:
      default:
        return <NotFoundPage translations={jsonTranslations} />;
    }
  };

  return (
    <>
      <ToastWrapper translations={jsonTranslations} />
      {getComponent()}
    </>
  );
}

export default Main;
